import axios from "axios";
import apiPaths from "./endpoints";
import config from "../config/environment";
import { getUserSession } from "../utils/accesstoken";
import { triggerLogout } from "../auth/logout";

// Create instance
const apiClient = axios.create({
  baseURL: apiPaths.CONTENT_BASE_URL3,
  timeout: config.apiTimeout,
  headers: {
    "Content-Type": "application/json",
  },
});

// Request interceptor → attach token automatically
apiClient.interceptors.request.use(
  async (config) => {
    // This will fetch session AND store token in localStorage if needed
    const accessToken = await getUserSession();

    // You can also read from localStorage as fallback
    const token = accessToken || localStorage.getItem("userAccessToken");

    if (token) {
      config.headers.Authorization = `${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor → global error handling
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // triggerLogout handles all error paths internally and does not throw.
      triggerLogout("session_expired");
    }

    return Promise.reject(error);
  }
);

export default apiClient;
